// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__2SZJf","row":"styles_row__Xk18K"};